import React, { useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import close from "../../Assets/close.svg";
import logo from "../../Assets/logo.png";
import Facebook from "../../Assets/homepage_icons/Facebook.svg";
import Instagram from "../../Assets/homepage_icons/Instagram.svg";
import LinkedIn from "../../Assets/homepage_icons/LinkedIn.svg";
import Reddit from "../../Assets/homepage_icons/Reddit.svg";
import Twitter from "../../Assets/homepage_icons/Twitter.svg";
import Youtube from "../../Assets/homepage_icons/Youtube.svg";
import Footer from "../Homepage footer/Footer";


const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const isUserAuthenticated = useSelector(
    (store) => store?.authStates?.isUserAuthenticated
  );
  const userName = useSelector((store) => store?.user?.FirstName);

  const navItems = [
    { label: 'About', path: '/' },
    { label: 'Pricing', path: '/pricing' },
    {label : 'Services' , dropdown: [
      { label: 'For Candidates', path: '/services/candidates' },
      { label: 'For Recruiter', path: '/services/recruiter' }
    ]},
    { label: 'Teams', path: '/our-teams' },
    { label: 'White Label', url: 'https://forms.zohopublic.in/rohitzepc1/form/WhiteLabelZepcruitforYourAgency/formperma/35LDKAOhH821LVH4H7AP1Ss8HRNrQcXaAI9vge17yWE' },
  ];

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex justify-center pt-4 sticky  top-0 z-50">
      <nav className="flex items-center justify-between w-[90%] md:w-[70%] bg-gray-50 px-6 py-2 rounded-full shadow-[0_1px_8px_rgba(0,0,0,0.20)] border border-white relative">
        {/* Logo */}
        <div>
          <button onClick={() => navigate('/')} >
            <img src={logo} alt="Logo" className="w-32 -mb-1" />
          </button>
        </div>

        {/* Desktop Navigation Links */}
        <div className="hidden md:flex space-x-6 text-lg font-medium">
          {navItems.map((item, index) => (
            <div key={index} className="relative group  hover:-translate-y-1">
              <a
                onClick={() => item.path ? navigate(item.path) : item.url ? window.open(item.url) : ''}
                className={` hover:font-semibold cursor-pointer transform transition-transform duration-200 group-hover:-translate-y-1 ${currentPath === item.path ? 'text-black font-semibold' : 'text-black font-extralight'
                  } hover:text-gray-700`}
              >
                {item.label}
              </a>
              {!item.dropdown && <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full h-2 w-2 rounded-full bg-primary-color-900 opacity-0 scale-0 group-hover:opacity-100 group-hover:scale-100 transition-all duration-100 ease-out"></span>}
              
              {item.dropdown && (
                <div className="absolute top-full left-0 mt-3 bg-white shadow-lg rounded-lg py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 min-w-[180px]">
                  {item.dropdown.map((dropItem, dropIndex) => (
                    <a
                      key={dropIndex}
                      onClick={() => navigate(dropItem.path)}
                      className="block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                    >
                      {dropItem.label}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>


        <div>
          {/* Desktop Auth Button */}
          {isUserAuthenticated ? (
            <button
              className="hidden md:block border border-black rounded-full px-5 py-1 text-sm hover:bg-black hover:text-white"
              onClick={() => navigate('/dashboard')}
            >
              {userName ? userName : "My Account"}
            </button>
          ) : (
            <button
              className="hidden md:block border border-black rounded-full px-5 py-1 text-sm hover:bg-black hover:text-white"
              onClick={() => navigate('/auth')}
            >
              Sign In / Up
            </button>
          )}
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden ">
          <button onClick={() => setIsOpen(true)}>
            <div className="w-6 h-0.5 bg-black mb-1"></div>
            <div className="w-6 h-0.5 bg-black mb-1"></div>
            <div className="w-6 h-0.5 bg-black"></div>
          </button>
        </div>

        {/* Mobile Full-Screen Menu */}
        {isOpen && (
          <div className="fixed top-0 left-0 w-full h-full bg-[#EDEBDA] flex flex-col justify-between pt-5 pb-6 z-50 overflow-y-auto">

            {/* Close Button */}
            <button onClick={() => setIsOpen(false)} className="absolute top-6 right-6">
              <img src={close} alt="Close" className="w-6 h-6" />
            </button>

            {/* Logo */}
            <div className="flex flex-col items-center">
              <img src={logo} alt="Logo" className="w-32 mb-6" />

              {/* Navigation Links */}
              <nav className="flex flex-col items-center space-y-6 text-xl font-medium">
                <a className={`cursor-pointer ${currentPath === '/' ? 'text-black font-bold' : 'text-black font-extralight'}`} onClick={() => navigate('/')}>About</a>
                <a className={`cursor-pointer ${currentPath === '/pricing' ? 'text-black font-bold' : 'text-black font-extralight'}`} onClick={() => navigate('/pricing')}>Pricing</a>
                <a className={`cursor-pointer ${currentPath === '/services/candidates' ? 'text-black font-bold' : 'text-black font-extralight'}`} onClick={() => navigate('/services/candidates')}>For Candidates</a>
                <a className={`cursor-pointer ${currentPath === '/services/recruiter' ? 'text-black font-bold' : 'text-black font-extralight'}`} onClick={() => navigate('/services/recruiter')}>For Recruiter</a>
                <a className={`cursor-pointer ${currentPath === '/our-teams' ? 'text-black font-bold' : 'text-black font-extralight'}`} onClick={() => navigate('/our-teams')}>Teams</a>
                <a className={`cursor-pointer text-black font-extralight `} onClick={() => window.open(navItems[4]?.url)}>White Label</a>
                {/* <a className={`cursor-pointer ${currentPath === '/auth' ? 'text-black font-bold' : 'text-black font-extralight'}`} onClick={() => navigate('/auth')}>Sign Up/Sign In</a> */}
                {/* Authentication-aware menu item */}
                {isUserAuthenticated ? (
                  <a
                    className={`cursor-pointer ${currentPath === '/dashboard' ? 'text-black font-bold' : 'text-black font-extralight'}`}
                    onClick={() => navigate('/dashboard')}
                  >
                    {userName ? userName : "My Account"}
                  </a>
                ) : (
                  <a
                    className={`cursor-pointer ${currentPath === '/auth' ? 'text-black font-bold' : 'text-black font-extralight'}`}
                    onClick={() => navigate('/auth')}
                  >
                    Sign Up/Sign In
                  </a>
                )}
                <div>
                  {/* Desktop Auth Button */}
                  {isUserAuthenticated ? (
                    <button
                      className="hidden md:block border border-black rounded-full px-5 py-1 text-sm hover:bg-black hover:text-white"
                      onClick={() => navigate('/dashboard')} // or dashboard/profile
                    >
                      {userName ? userName : "My Account"}
                    </button>
                  ) : (
                    <button
                      className="hidden md:block border border-black rounded-full px-5 py-1 text-sm hover:bg-black hover:text-white"
                      onClick={() => navigate('/auth')}
                    >
                      Sign In / Up
                    </button>
                  )}
                </div>
              </nav>
            </div>
            <Footer isCompanyLogoRequired={false} />
          </div>
        )}

      </nav>
    </div>
  );
};

export default Navbar;
